import styled from "@emotion/styled/macro";
import { type ReactNode, type PropsWithChildren } from "react";
import { useMediaQuery } from "react-responsive";
import { TaskHeader } from "../molecules/TaskHeader";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";

type TaskViewTemplateProps = PropsWithChildren<{
  showAdditionalSystemPill?: boolean;
  loading?: boolean;
  icon: string | ReactNode;
  title: string;
}>;

const TaskViewTemplate = ({
  showAdditionalSystemPill,
  loading,
  children,
  icon,
  title,
}: TaskViewTemplateProps) => {
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth });
  return (
    <Wrapper isMobile={isMobile}>
      {!loading && (
        <TaskHeader
          icon={icon}
          label={title}
          showAdditionalSystemPill={showAdditionalSystemPill}
        />
      )}
      <Content>{children}</Content>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isMobile?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.isMobile ? "16px" : "32px")};
`;
const Content = styled.main``;

export { TaskViewTemplate };
export type { TaskViewTemplateProps };
